import styled from "styled-components";

export const TableWrapper = styled.table`
  width: 100%;
  margin-top: 20px;

  tbody {
    margin-top: 5px;
  }

  td {
    padding: 5px 5px;
  }
`;
